<template>
  <section class="con-swiper-3">
    <div class="title-wrap text-center" v-if="books.length > 0">
      <h2 class="h1-style">ملازم اخري</h2>
      <hr />
      <br />
    </div>
    <!-- Books Slider ~~:breakpoints="swiperOptions.breakpoints" -->
    <swiper
      class="mySwiper-3 swiper prd-grid data-to-show-4 data-to-show-md-2 data-to-show-sm-2 data-to-show-xs-1 js-product-grid-sm parallax-slider"
      :slidesPerView="4"
      :spaceBetween="0"
      :slidesPerGroup="1"
      :loop="true"
      :autoplay="true"
      :pauseOnMouseEnter="true"
      :loopFillGroupWithBlank="true"
      :navigation="true"
      :modules="modules_3"
      v-if="books.length > 0"
    >
      <swiper-slide
        :data-swiper-autoplay="5000"
        class="swiper-slide prd prd--style2 prd-labels--max prd-labels-shadow"
        v-for="book in books"
        :key="book.id"
      >
        <div class="prd-inside">
          <div class="prd-img-area">
            <router-link :to="{ name: 'Book', params: { id: book.id } }" class="prd-img image-hover-scale image-container">
              <img
                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                :data-src="book.image"
                alt="The Book 01"
                class="js-prd-img lazyload fade-up"
              />
              <div class="foxic-loader"></div>
              <div class="prd-big-squared-labels"></div>
            </router-link>
            <div class="prd-circle-labels">
              <router-link :to="{ name: 'Book', params: { id: book.id } }" class="circle-label-qview prd-hide-mobile"
                ><i class="icon-eye"></i><span>عرض الكتاب</span></router-link
              >
            </div>
          </div>
          <div class="prd-info">
            <div class="prd-info-wrap">
              <h2 class="prd-title">
                <router-link :to="{ name: 'Book', params: { id: book.id } }">{{ book.name }}</router-link>
              </h2>
              <div class="prd-description cut-text">
                {{ book.description }}
              </div>
              <div class="prd-block_description prd-block_info_item purchase-count">
                <h3>عدد الشراء</h3>
                <p>
                  {{ book.purchase_count }}
                </p>
                <div class="mt-1"></div>
              </div>
            </div>
            <div class="prd-hovers">
              <div class="prd-price">
                <div class="price-new">{{ book.price }} ريال</div>
                <div class="prd-tag discount">{{ book.discount }} ريال</div>
              </div>
              <div class="prd-action">
                <div class="prd-action-left">
                  <form class="form-submit" @submit.prevent.stop="() => console.log()">
                    <button
                      type="submit"
                      @click.prevent="$event.target.classList.add('active')"
                      @click.prevent.stop="
                        SET_CART_ID_TO_LS({ id: book.id, qty: 1 });
                        ANIMATE_ADD_TO_CART({ srcImage: book.image, ele: 'books' });
                      "
                      class="btn js-prd-addtocart handel-click"
                      :class="{ active: book.isActive }"
                    >
                      إضافة للسلة
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div
      class="books prd-grid data-to-show-4 data-to-show-md-2 data-to-show-sm-2 data-to-show-xs-1 js-product-grid-sm parallax-slider"
    >
      <div class="prd prd--style2 prd-labels--max prd-labels-shadow" v-for="book in books" :key="book.id">
        <div class="prd-inside">
          <div class="prd-img-area">
            <router-link :to="{ name: 'Book', params: { id: book.id } }" class="prd-img image-hover-scale image-container">
              <img
                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                :data-src="book.image"
                alt="The Book 01"
                class="js-prd-img lazyload fade-up"
              />
              <div class="foxic-loader"></div>
              <div class="prd-big-squared-labels"></div>
            </router-link>
          </div>
          <div class="prd-info">
            <div class="prd-info-wrap">
              <h2 class="prd-title">
                <router-link :to="{ name: 'Book', params: { id: book.id } }">{{ book.name }}</router-link>
              </h2>
              <div class="prd-description cut-text">
                {{ book.description }}
              </div>
            </div>
            <div class="prd-hovers">
              <div class="prd-circle-labels">
                <div>
                  <a href="#" class="circle-label-compare circle-label-wishlist--add js-add-wishlist mt-0" title="Add To Wishlist"
                    ><i class="icon-heart-stroke"></i></a
                  ><a
                    href="#"
                    class="circle-label-compare circle-label-wishlist--off js-remove-wishlist mt-0"
                    title="Remove From Wishlist"
                    ><i class="icon-heart-hover"></i
                  ></a>
                </div>
              </div>
              <div class="prd-price">
                <div class="price-new">{{ book.price }} ريال</div>
                <div class="prd-tag discount">{{ book.discount }} ريال</div>
              </div>
              <div class="prd-action">
                <div class="prd-action-left">
                  <form class="form-submit" @submit.prevent.stop="() => console.log()">
                    <button
                      type="submit"
                      @click.prevent="$event.target.classList.add('active')"
                      @click.prevent.stop="
                        SET_CART_ID_TO_LS({ id: book.id, qty: 1 });
                        ANIMATE_ADD_TO_CART({ srcImage: book.image, ele: 'books' });
                      "
                      class="btn js-prd-addtocart handel-click"
                      :class="{ active: book.isActive }"
                    >
                      <i class="fa fa-cart-plus"></i>
                      إضافة للسلة
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Swiper, SwiperSlide } from "swiper/vue";
// import required modules
import { Navigation, Autoplay, Pagination } from "swiper";
export default {
  name: "Swiper_3",
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    ...mapState("Books", ["books"]),
  },
  async mounted() {
    await this.GET_BOOKS();
  },
  data() {
    return {
      pagination: {
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      modules_3: [Navigation, Autoplay, Pagination],
    };
  },
  methods: {
    ...mapActions("Books", ["GET_BOOKS"]),
    ...mapActions("Cart", ["SET_CART_ID_TO_LS"]),
    ...mapActions("Global", ["ANIMATE_ADD_TO_CART"]),
  },
};
</script>
<style lang="scss">
.mySwiper-3 {
  padding-bottom: 100px !important;
  padding-right: 6px !important;
}
</style>
